import { render, staticRenderFns } from "./OmsReport.vue?vue&type=template&id=142cf442"
import script from "./OmsReport.vue?vue&type=script&lang=js"
export * from "./OmsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports